import React from "react";
import {
  BILLING_DAFTAR_PENJUALAN,
  BILLING_INPUT_PENJUALAN,
  BILLING_DAFTAR_TAGIHAN,
  BILLING_INPUT_TAGIHAN,
  BILLING_SERVICE_TUTUP_TAGIHAN,
  BILLING_DAFTAR_PEMBAYARAN_TAGIHAN,
  BILLING_SALDO,
  RT_INPUT_REKAP_TAGIHAN,
  RT_DAFTAR_REKAP_TAGIHAN,
  RT_AGGING_PIUTANG_REKAP,
  RT_DAFTAR_PEMBAYARAN_REKAP,
  MS_HARGA_TARIF,
  BILLING_MS_RINCIAN_JASMED,
  BILLING_REKAP_JASMED,
  BILLING_REKAP_DETAIL_JASMED,
  BILLING_LAPORAN_PENJUALAN,
  BILLING_RETUR_PENJUALAN,
  BILLING_SERVICE_TUTUP_PENJUALAN,
  SETTING_AUTO_BILLING,
  BILLING_AUTO_TAGIHAN,
  BILLING_HR_KAS_BON_DOKTER,
  MS_UPDATE_HARGA_TARIF,
} from "App/constants";

import {
  DaftarPembayaranTagihan,
  DaftarPenjualan,
  DaftarTagihan,
  InputPenjualan,
  InputTagihan,
  SaldoTagihan,
  ServiceTutupTagihan,
  InputRekapTagihan,
  DaftarRekapTagihan,
  AggingPiutangRekap,
  DaftarPembayaranRekap,
  MasterHargaTarif,
  MasterRincianJasmedPage,
  RekapJasmedPage,
  DetailRekapJasmedPage,
  LaporanPenjualan,
  ServiceTutupPenjualan,
  ReturPenjualanPage,
  AutoBillingPage,
  TagihanOtomatis,
  KasBonDokter,
  UpdateHargaTarif,
} from "../WrapperLazyExport";

export const menuBilling = {
  [MS_HARGA_TARIF]: <MasterHargaTarif />,
  [BILLING_DAFTAR_PENJUALAN]: <DaftarPenjualan />,
  [BILLING_INPUT_PENJUALAN]: <InputPenjualan />,
  [BILLING_DAFTAR_TAGIHAN]: <DaftarTagihan />,
  [BILLING_INPUT_TAGIHAN]: <InputTagihan />,
  [BILLING_SERVICE_TUTUP_TAGIHAN]: <ServiceTutupTagihan />,
  [BILLING_DAFTAR_PEMBAYARAN_TAGIHAN]: <DaftarPembayaranTagihan />,
  [BILLING_SALDO]: <SaldoTagihan />,
  [SETTING_AUTO_BILLING]: <AutoBillingPage />,
  [BILLING_AUTO_TAGIHAN]: <TagihanOtomatis />,

  [BILLING_MS_RINCIAN_JASMED]: <MasterRincianJasmedPage />,
  [BILLING_REKAP_JASMED]: <RekapJasmedPage />,
  [BILLING_REKAP_DETAIL_JASMED]: <DetailRekapJasmedPage />,
  [BILLING_SERVICE_TUTUP_PENJUALAN]: <ServiceTutupPenjualan />,
  [BILLING_RETUR_PENJUALAN]: <ReturPenjualanPage />,
  [BILLING_LAPORAN_PENJUALAN]: <LaporanPenjualan />,
  
  [BILLING_HR_KAS_BON_DOKTER]: <KasBonDokter />,
  [MS_UPDATE_HARGA_TARIF]: <UpdateHargaTarif />,
};

export const menuRekapTagihan = {
  [RT_INPUT_REKAP_TAGIHAN]: <InputRekapTagihan />,
  [RT_DAFTAR_REKAP_TAGIHAN]: <DaftarRekapTagihan />,
  [RT_DAFTAR_PEMBAYARAN_REKAP]: <DaftarPembayaranRekap />,
  [RT_AGGING_PIUTANG_REKAP]: <AggingPiutangRekap />,
};
